const REFERRAL_KEY = "ref";

export function saveReferralId(refId: string) {
  localStorage.setItem(REFERRAL_KEY, refId);
}

export function getReferralId() {
  return localStorage.getItem(REFERRAL_KEY) ?? undefined;
}
